import {growthBookFeatureFlags} from '@/utils/constants/growthBookFeatureFlags'
import {useFeatureValue} from '@growthbook/growthbook-react'
import {getCountryCode} from '@/helpers/shadcn/utils'

const fallbackLanguages = [
  {
    language: 'English',
    code: 'en',
  },
  {
    language: 'Spanish (Mexico)',
    code: 'es_MX',
  },
]

export const useFeatureFlagLanguages = () => {
  const countryCode = getCountryCode()
  const countryLanguages = useFeatureValue(growthBookFeatureFlags.languageList, {})
  const langauges = (countryLanguages[countryCode] || fallbackLanguages).map(item => ({
    ...item,
    code: item.code.replace('-', '_'),
  }))

  return langauges || []
}
